/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateTournamentAdminItemDto = {
  name?: string;
  sourceType?: UpdateTournamentAdminItemDto.sourceType;
  mediaUrl?: string;
};
export namespace UpdateTournamentAdminItemDto {
  export enum sourceType {
    IMAGE = "IMAGE",
    YOUTUBE_SHORTS = "YOUTUBE_SHORTS",
  }
}
